import PriceService from "@/services/nwapp/price.service";

export const priceApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getProgramOptionField({ commit }, fileData) {
      return PriceService.getProgramOptionField(fileData).then(
        (resp) => {
          commit("dummy", "PriceService.getProgramOptionField - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "PriceService.getProgramOptionField - error");
          return Promise.reject(error.response);
        }
      );
    },
    investorPricingByFileData({ commit }, fileData) {
      return PriceService.investorPricingByFileData(fileData).then(
        (resp) => {
          commit("dummy", "PriceService.investorPricingByFileData - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "PriceService.investorPricingByFileData - error");
          return Promise.reject(error.response);
        }
      );
    },
    investorMultiPricing({ commit }, { loanNumbers, investorIds }) {
      return PriceService.investorMultiPricing(loanNumbers, investorIds).then(
        (resp) => {
          commit("dummy", "PriceService.investorMultiPricing - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "PriceService.investorMultiPricing - error");
          return Promise.reject(error.response);
        }
      );
    },
    getLoanPadding({ commit }, loanNumber) {
      return PriceService.getLoanPadding(loanNumber).then(
        (resp) => {
          commit("dummy", "PriceService.getLoanPadding - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "PriceService.getLoanPadding - error");
          return Promise.reject(error.response);
        }
      );
    },
    getBrokerPadding({ commit }, organizationId) {
      return PriceService.getBrokerPadding(organizationId).then(
        (resp) => {
          commit("dummy", "PriceService.getBrokerPadding - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "PriceService.getBrokerPadding - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
